export function deleteAllCookies() {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  export function getSortName(param: string): string {
    const name = param && param.split(" ");
    const sortName = name && (name[0].charAt(0) + name[1].charAt(0));
    return sortName;
  }
  
  export function getDisplayName(param: string): string {
    return param && param.split(" ")[0];
  }

  export function stringToDate(str: any) {
    const [dd, mm, yyyy] = str.split('-');
    return new Date(yyyy, mm - 1, dd);
  }


